import { render } from "./EditInternshipPartModal.vue?vue&type=template&id=1f0d0a58&ts=true"
import script from "./EditInternshipPartModal.vue?vue&type=script&lang=ts"
export * from "./EditInternshipPartModal.vue?vue&type=script&lang=ts"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__